import { render, staticRenderFns } from "./OtherExpenses.vue?vue&type=template&id=1f14feed&scoped=true&"
import script from "./OtherExpenses.vue?vue&type=script&lang=js&"
export * from "./OtherExpenses.vue?vue&type=script&lang=js&"
import style0 from "./OtherExpenses.vue?vue&type=style&index=0&id=1f14feed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f14feed",
  null
  
)

export default component.exports